import { alpha } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

interface CollaborationStepContainerProps extends PropsWithChildren {
  testId: string;
}

export const CollaborationStepContainer: FC<
  CollaborationStepContainerProps
> = ({ children, testId }) => {
  return <Container data-testid={testId}>{children}</Container>;
};

const Container = styled('div')`
  width: 266px;
  border-radius: 8px;
  padding: ${theme.spacing(9)};
  background-color: ${alpha(theme.palette.grey[900], 0.6)};
`;
